import { FC, useEffect, useMemo, useState } from 'react';
import { Grid, Paper} from '@mui/material';
import { useInterval } from 'hooks/useInterval';
import { io } from 'socket.io-client';
import { SocketTreatmentEvents } from 'types';
import { useParams } from 'react-router-dom';
import { Button } from 'components/Button';

export const B2B: FC = () => {
  const { tutorId, queuePosition, tutorName, callCode } = useParams<{ tutorId: string, queuePosition: any, tutorName: any, callCode?: any }>();
  const REFRESH_INTERVAL = 1000 * 60 * 2; // two minutes to refresh queue if socket disconnect
  const [position, setPosition] = useState(queuePosition);
  const [isOnCall, setIsOnCall] = useState(false);
  const [isCallFinished, setIsCallFinished] = useState(false);
  const [callUrl, setCallUrl] = useState('');
  
  //TODO: SERVICE PARA PEGAR POSIÇÃO NA HORA
  const socket = useMemo(() => {
    return io(process.env.REACT_APP_BASE_API_URL as string, { path: '/ws' });
  }, []);
  
  
  useEffect(() => {
    if (queuePosition == 0) {
      setCallUrl('https://videochamada.prod.vet4all.com.br/' + callCode);
      setIsOnCall(true);
    }


    socket.connect();
    socket.on(SocketTreatmentEvents.CONNECT, () => {
      socket.emit(SocketTreatmentEvents.TUTOR_TREATMENT_JOIN_WAITING, {
        tutorId,
      });

      /* Tutor is waiting and watch position on queue */
      socket.on(
        SocketTreatmentEvents.TUTOR_TREATMENT_WAITING_UPDATE_POSITION,
        (data: { position: number }) => {
          setPosition(data?.position || 0);
        },
      );

      /* Vet is calling tutor */
      socket.once(
        SocketTreatmentEvents.TUTOR_TREATMENT_WAITING_INCOMING_CALL,
        (
          data: any & { vet: { name: string; crmv: string } },
        ) => {

         setIsOnCall(true);
         setCallUrl(data.callUrl)
        },
      );

      /* Vet has finished the treament */
      socket.on(
        SocketTreatmentEvents.TUTOR_TREATMENT_FINISH_CALL,
        ({ treatmentId }: { treatmentId: string }) => {
          setIsCallFinished(true);
          setIsOnCall(false);
          try {
            //o que fazer quando o vet terminar a chamada
          } catch (reason) {}
        },
      );      
    });

    return () => {
      socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Force refresh on specific interval if socket has not receiving connections
  useInterval(() => {
    if (socket.disconnected) {
      socket.connect();
    }

  }, REFRESH_INTERVAL);

  return (
    <>

    {
      isOnCall ? 
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{ backgroundColor: 'black', display: isOnCall ? 'flex' : 'flex', height: '100vh' }}
        >
          
          {isCallFinished ? <></> : 
              <>
                <iframe id="iframe" allow="camera *;microphone *" src={callUrl + `#config.deeplinking.disabled=true&userinfo.displayname="${tutorName}"` } 
                  style={{ display: isOnCall ? 'flex' : 'none', width: '100%', height: '90%', border: 'none' }} 
                />
                <Button 
                  onClick={() => { setIsCallFinished(true); setIsOnCall(false); } } 
                  style={{ marginBottom: '5px', backgroundColor: '#438eb9' }}>Encerrar Atendimento
                </Button>
              </>
          }
    
          </Grid> :  
          <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              style={{ background: 'url(https://the-dock-324821.web.app/static/media/dog-being-checked-by-the-vet-at-the-pet-shop2.76072972.png) no-repeat center center', display: isOnCall ? 'none' : 'flex', height: '100vh' }}
      
            >
          {isCallFinished ?
          <Paper style={{backgroundColor: '#438eb9', justifyContent: 'center', textAlign: 'center', opacity: 0.9}}  variant="outlined" sx={{ py: 12, px: 8 }}>
            <p style={{fontWeight: 500, color: 'white'}}>Atendimento encerrado, agora você já pode fechar esta janela.</p>
          </Paper> 
          : 
          <Paper style={{backgroundColor: '#438eb9', justifyContent: 'center', textAlign: 'center', opacity: 0.9}} variant="outlined" sx={{ py: 12, px: 8 }}>
            <p style={{fontWeight: 500, color: 'white'}}>{position == 1 ? 'Você é o próximo da fila, mantenha-se na tela para ser atendido.' : `Você é o ${position}° da fila, mantenha-se na tela para ser atendido.` }</p>
          </Paper>}
        </Grid> 
    }
 
    </>
  );
};

